import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CtaDirective } from './directives/cta/cta.directive';
import { PopupDirective } from './directives/popup/popup.directive';

@NgModule({
  declarations: [CtaDirective, PopupDirective],
  imports: [CommonModule],
  exports: [CtaDirective, PopupDirective]
})
export class AnalyticsModule {}
